export default function (element, data) {
    const spritesheetCols = data.spritesheetCols;
    const spritesheetRows = data.spritesheetRows;
    const fps = data.fps;
    const frames = data.frames;
    const frameDuration = 1000 / fps;
    const startTime = performance.now();
    let width = 0;
    let height = 0;
    let prevFrameIndex = null;

    updateSize();
    window.addEventListener("redize", updateSize);

    requestAnimationFrame(animate);

    function animate() {
        const elapsed = performance.now() - startTime;
        const frameIndex = Math.floor(elapsed / frameDuration) % frames;
        if (frameIndex !== prevFrameIndex) {
            const col = frameIndex % spritesheetCols;
            const row = Math.floor(frameIndex / spritesheetCols);
            
            const offsetX = -col * width;
            const offsetY = -row * height;

            element.style.backgroundPosition = offsetX + "px " + offsetY + "px";
            prevFrameIndex = frameIndex;
        }

        requestAnimationFrame(animate);
    }

    function updateSize() {
        width = Math.round(element.offsetWidth);
        height = Math.round(element.offsetHeight);

        const backgroundWidth = width * spritesheetCols;
        const backgroundHeight = height * spritesheetRows;

        element.style.backgroundSize = backgroundWidth + "px " + backgroundHeight + "px";
    }
}
